import React from 'react';

import Button from '@uikit/Form/Button/Button';
import ColoredLabel from '@uikit/old/ColoredLabel/ColoredLabel';
import { TableConfigType } from '@uikit/old/ConfigurableTable/ConfigurableTable';
import { SVGIcon } from '@uikit/old/Icon/Icon';
import TimestampToDate from '@uikit/TimestampToDate/TimestampToDate';

import { statusLabelColor } from '../../utils';

export type InvoicesTableRenderProps = {
  onDownload: (id: number) => void;
  activeDownloadId: number | null;
};

export const invoicesTableConfig: TableConfigType = [
  { title: 'Invoice ID', dataKey: 'number' },
  {
    title: 'Date / time Created',
    dataKey: 'date',
    cellClassName: 'invoices-table__date-cell',
    RenderCell: ({ row }) => (
      <>
        <div>
          <TimestampToDate timestamp={row.date} hideTime />
        </div>
        <div>
          <TimestampToDate timestamp={row.date} timeOnly />
        </div>
      </>
    ),
  },
  { title: 'Website', dataKey: 'websiteDomain' },
  {
    title: 'Status',
    dataKey: 'statusFormatted',
    RenderCell: ({ row }) => (
      <ColoredLabel color={statusLabelColor(row.statusFormatted)}>
        {row.statusFormatted}
      </ColoredLabel>
    ),
  },
  { title: 'Amount', dataKey: 'amountFormatted' },
  {
    title: 'Receipt',
    dataKey: 'receipt',
    RenderCell: ({ row, renderProps }) => (
      <Button
        className="invoices-table__receipt-btn"
        type="blue"
        size="xs"
        onClick={() => (renderProps as InvoicesTableRenderProps).onDownload(row.id)}
        isLoading={(renderProps as InvoicesTableRenderProps).activeDownloadId === row.id}
        disabled={(renderProps as InvoicesTableRenderProps).activeDownloadId !== null}
      >
        <SVGIcon icon="download" size={8} />
      </Button>
    ),
  },
];
